import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";

const LegacyTable = (props) => {
  const theme = useTheme();
  const [rowsData, setRowsData] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    for (let d = 0; d < props?.data?.length; d++) {
      let row = [];

      const data = props.data[d];

      for (let c = 0; c < props?.columns?.length; c++) {
        const column = props.columns[c];

        let display = data[column.accessor];

        if (column.Cell !== undefined) {
          display = column.Cell({
            value: data[column.accessor]
          });
        }

        row.push(<TableCell key={d + c} align="right">{display}</TableCell>);
      }

      setRowsData((prev) => [
        ...prev,
        <TableRow key={d} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
          {row}
        </TableRow>
      ]);
    }

    for (let c = 0; c < props?.columns?.length; c++) {
      const column = props.columns[c];
      setHeaders((prev) => [
        ...prev,
        <TableCell key={c} align="right">{column?.name}</TableCell>
      ]);
    }
  }, [props.data, props.columns]);

  return (
    <TableContainer component={Paper}>
      {rowsData.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            padding: "32px",
            color: theme?.custom?.grayLabelText
          }}
        >
          No data to view.
        </Box>
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label="innovation within table">
          <TableHead>
            <TableRow>{headers}</TableRow>
          </TableHead>
          <TableBody>{rowsData?.length > 0 && rowsData}</TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default LegacyTable;
